export default {
  form: {
    preparation_time: {
      label: 'Voer aangepaste tijd in (minuten):',
      placeholder: 'Voer minuten in',
    },
  },
  buttons: {
    custom: 'Aangepast',
  },
  feedback: {
    preparation_time_required: 'Bereidingstijd moet meer dan 0 minuten zijn',
    min_preparation_time: 'Minimaal {{minutes}} minuten bereidingstijd voor externe bezorging',
    max_preparation_time: 'Maximaal {{minutes}} minuten bereidingstijd',
  },
};
